<template>
  <div class="section catalogue">
    <el-row type="flex" class="grids" :gutter="30">
      <el-col class="item" :span="6" v-for="(item, idx) in items" :key="idx">
        <el-image
          @click="downloadFile(item)"
          class="cover"
          :lazy="true"
          :src="item.cover"
        ></el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import LoadMore from "./LoadMore.vue";
export default {
  name: "Catalogue",
  components: {
    LoadMore,
  },
  props: {
    items: {
      default: [],
    },
  },
  methods: {
    downloadFile(item) {
      window.open(item.file);
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.grids {
  margin-left: 195px !important;
  margin-right: 195px !important;
  flex-wrap: wrap;

  .item {
    margin-bottom: 120px;
    display: flex;

    align-items: flex-end;
    box-sizing: border-box;

    .cover {
      cursor: pointer;
    }
  }
}
</style>
